export const clientsInitialState = [
  {
    profile: {
      id: 1,
      name: 'John Anderson',
      email: 'john.anderson@email.com',
      phone: '+1 (555) 123-4567',
      company: 'Anderson & Co.',
      address: '',
      dateOfBirth: '1996-05-27',
      joinDate: '2023-01-15',
      status: 'active',
      type: 'individual',
      avatar: 'JA',
      tags: ['Standard'],
      notes: '',
    },
    policies: [
      {
        id: 1,
        type: 'Life Insurance',
        policyNumber: 'POL-2023-001',
        coverage: 150000,
        premium: 125,
        status: 'active',
        startDate: '2023-01-20',
        endDate: '2024-01-20',
        color: 'blue',
      },
      {
        id: 2,
        type: 'Health Insurance',
        policyNumber: 'POL-2023-045',
        coverage: 75000,
        premium: 200,
        status: 'active',
        startDate: '2023-02-15',
        endDate: '2024-02-15',
        color: 'green',
      },
      {
        id: 3,
        type: 'Auto Insurance',
        policyNumber: 'POL-2023-089',
        coverage: 25000,
        premium: 150,
        status: 'expiring',
        startDate: '2023-03-10',
        endDate: '2024-03-10',
        color: 'orange',
      },
    ],
    claims: [
      {
        id: 1,
        claimNumber: 'CLM-2024-123',
        type: 'Health Insurance',
        amount: 2500,
        status: 'approved',
        date: '2024-01-15',
        description: 'Medical procedure claim',
      },
      {
        id: 2,
        claimNumber: 'CLM-2024-089',
        type: 'Auto Insurance',
        amount: 1200,
        status: 'processing',
        date: '2024-02-20',
        description: 'Vehicle repair claim',
      },
      {
        id: 3,
        claimNumber: 'CLM-2023-456',
        type: 'Health Insurance',
        amount: 850,
        status: 'approved',
        date: '2023-11-10',
        description: 'Prescription medication',
      },
    ],
    documents: [
      {
        id: 1,
        name: 'Policy Agreement - Life Insurance.pdf',
        size: '2.4 MB',
        date: '2023-01-20',
        type: 'pdf',
      },
      { id: 2, name: 'Health Insurance Card.pdf', size: '156 KB', date: '2023-02-15', type: 'pdf' },
      { id: 3, name: 'Auto Policy Documents.pdf', size: '1.8 MB', date: '2023-03-10', type: 'pdf' },
      { id: 4, name: 'ID Verification.jpg', size: '890 KB', date: '2023-01-15', type: 'image' },
    ],
    activities: [
      { id: 1, type: 'policy', action: 'Policy renewed', date: '2 hours ago', icon: 'file' },
      { id: 2, type: 'claim', action: 'Claim approved', date: '1 day ago', icon: 'check' },
      { id: 3, type: 'payment', action: 'Premium paid', date: '3 days ago', icon: 'dollar' },
      { id: 4, type: 'document', action: 'Document uploaded', date: '1 week ago', icon: 'upload' },
      {
        id: 5,
        type: 'meeting',
        action: 'Client meeting scheduled',
        date: '2 weeks ago',
        icon: 'calendar',
      },
    ],
  },
  {
    profile: {
      id: 2,
      name: 'Sarah Martinez',
      email: 'sarah.m@techcorp.com',
      phone: '+1 (555) 234-5678',
      company: 'TechCorp Inc.',
      address: '',
      dateOfBirth: '1996-05-27',
      joinDate: '2023-02-20',
      status: 'active',
      type: 'business',
      avatar: 'SM',
      tags: ['Standard'],
      notes: '',
    },
    policies: [
      {
        id: 1,
        type: 'Life Insurance',
        policyNumber: 'POL-2023-001',
        coverage: 150000,
        premium: 125,
        status: 'active',
        startDate: '2023-01-20',
        endDate: '2024-01-20',
        color: 'blue',
      },
    ],
    claims: [
      {
        id: 1,
        claimNumber: 'CLM-2024-123',
        type: 'Health Insurance',
        amount: 2500,
        status: 'approved',
        date: '2024-01-15',
        description: 'Medical procedure claim',
      },
    ],
    documents: [
      {
        id: 1,
        name: 'Policy Agreement - Life Insurance.pdf',
        size: '2.4 MB',
        date: '2023-01-20',
        type: 'pdf',
      },
      { id: 2, name: 'Health Insurance Card.pdf', size: '156 KB', date: '2023-02-15', type: 'pdf' },
      { id: 3, name: 'Auto Policy Documents.pdf', size: '1.8 MB', date: '2023-03-10', type: 'pdf' },
      { id: 4, name: 'ID Verification.jpg', size: '890 KB', date: '2023-01-15', type: 'image' },
    ],
    activities: [
      { id: 1, type: 'policy', action: 'Policy renewed', date: '2 hours ago', icon: 'file' },
      { id: 2, type: 'claim', action: 'Claim approved', date: '1 day ago', icon: 'check' },
      { id: 3, type: 'payment', action: 'Premium paid', date: '3 days ago', icon: 'dollar' },
      { id: 4, type: 'document', action: 'Document uploaded', date: '1 week ago', icon: 'upload' },
      {
        id: 5,
        type: 'meeting',
        action: 'Client meeting scheduled',
        date: '2 weeks ago',
        icon: 'calendar',
      },
    ],
  },
  {
    profile: {
      id: 3,
      name: 'Michael Chen',
      email: 'mchen@email.com',
      phone: '+1 (555) 345-6789',
      company: 'Self-employed',
      address: '',
      dateOfBirth: '1996-05-27',
      joinDate: '2023-03-10',
      status: 'pending',
      type: 'individual',
      avatar: 'MC',
      tags: ['Standard'],
      notes: '',
    },
    policies: [],
    claims: [],
    documents: [],
    activities: [],
  },
  {
    profile: {
      id: 4,
      name: 'Emily Rodriguez',
      email: 'emily.r@startup.io',
      phone: '+1 (555) 456-7890',
      company: 'Startup Innovations',
      address: '',
      dateOfBirth: '1996-05-27',
      joinDate: '2023-04-05',
      status: 'active',
      type: 'business',
      avatar: 'ER',
      tags: ['Standard'],
      notes: '',
    },
    policies: [
      {
        id: 1,
        type: 'Life Insurance',
        policyNumber: 'POL-2023-001',
        coverage: 150000,
        premium: 125,
        status: 'active',
        startDate: '2023-01-20',
        endDate: '2024-01-20',
        color: 'blue',
      },
      {
        id: 2,
        type: 'Health Insurance',
        policyNumber: 'POL-2023-045',
        coverage: 75000,
        premium: 200,
        status: 'active',
        startDate: '2023-02-15',
        endDate: '2024-02-15',
        color: 'green',
      },
    ],
    claims: [
      {
        id: 1,
        claimNumber: 'CLM-2024-123',
        type: 'Health Insurance',
        amount: 2500,
        status: 'approved',
        date: '2024-01-15',
        description: 'Medical procedure claim',
      },
      {
        id: 2,
        claimNumber: 'CLM-2024-089',
        type: 'Auto Insurance',
        amount: 1200,
        status: 'processing',
        date: '2024-02-20',
        description: 'Vehicle repair claim',
      },
    ],
    documents: [
      {
        id: 1,
        name: 'Policy Agreement - Life Insurance.pdf',
        size: '2.4 MB',
        date: '2023-01-20',
        type: 'pdf',
      },
      { id: 2, name: 'Health Insurance Card.pdf', size: '156 KB', date: '2023-02-15', type: 'pdf' },
      { id: 3, name: 'Auto Policy Documents.pdf', size: '1.8 MB', date: '2023-03-10', type: 'pdf' },
      { id: 4, name: 'ID Verification.jpg', size: '890 KB', date: '2023-01-15', type: 'image' },
    ],
    activities: [
      { id: 1, type: 'policy', action: 'Policy renewed', date: '2 hours ago', icon: 'file' },
      { id: 2, type: 'claim', action: 'Claim approved', date: '1 day ago', icon: 'check' },
      { id: 3, type: 'payment', action: 'Premium paid', date: '3 days ago', icon: 'dollar' },
      { id: 4, type: 'document', action: 'Document uploaded', date: '1 week ago', icon: 'upload' },
      {
        id: 5,
        type: 'meeting',
        action: 'Client meeting scheduled',
        date: '2 weeks ago',
        icon: 'calendar',
      },
    ],
  },
  {
    profile: {
      id: 5,
      name: 'David Thompson',
      email: 'dthompson@email.com',
      phone: '+1 (555) 567-8901',
      company: 'Thompson LLC',
      address: '',
      dateOfBirth: '1996-05-27',
      joinDate: '2023-05-12',
      status: 'inactive',
      type: 'individual',
      avatar: 'DT',
      tags: ['Standard'],
      notes: '',
    },
    policies: [
      {
        id: 1,
        type: 'Life Insurance',
        policyNumber: 'POL-2023-001',
        coverage: 150000,
        premium: 125,
        status: 'active',
        startDate: '2023-01-20',
        endDate: '2024-01-20',
        color: 'blue',
      },
      {
        id: 2,
        type: 'Health Insurance',
        policyNumber: 'POL-2023-045',
        coverage: 75000,
        premium: 200,
        status: 'active',
        startDate: '2023-02-15',
        endDate: '2024-02-15',
        color: 'green',
      },
      {
        id: 3,
        type: 'Auto Insurance',
        policyNumber: 'POL-2023-089',
        coverage: 25000,
        premium: 150,
        status: 'expiring',
        startDate: '2023-03-10',
        endDate: '2024-03-10',
        color: 'orange',
      },
    ],
    claims: [
      {
        id: 1,
        claimNumber: 'CLM-2024-123',
        type: 'Health Insurance',
        amount: 2500,
        status: 'approved',
        date: '2024-01-15',
        description: 'Medical procedure claim',
      },
      {
        id: 2,
        claimNumber: 'CLM-2024-089',
        type: 'Auto Insurance',
        amount: 1200,
        status: 'processing',
        date: '2024-02-20',
        description: 'Vehicle repair claim',
      },
      {
        id: 3,
        claimNumber: 'CLM-2023-456',
        type: 'Health Insurance',
        amount: 850,
        status: 'approved',
        date: '2023-11-10',
        description: 'Prescription medication',
      },
    ],
    documents: [
      {
        id: 1,
        name: 'Policy Agreement - Life Insurance.pdf',
        size: '2.4 MB',
        date: '2023-01-20',
        type: 'pdf',
      },
      { id: 2, name: 'Health Insurance Card.pdf', size: '156 KB', date: '2023-02-15', type: 'pdf' },
      { id: 3, name: 'Auto Policy Documents.pdf', size: '1.8 MB', date: '2023-03-10', type: 'pdf' },
      { id: 4, name: 'ID Verification.jpg', size: '890 KB', date: '2023-01-15', type: 'image' },
    ],
    activities: [
      { id: 1, type: 'policy', action: 'Policy renewed', date: '2 hours ago', icon: 'file' },
      { id: 2, type: 'claim', action: 'Claim approved', date: '1 day ago', icon: 'check' },
      { id: 3, type: 'payment', action: 'Premium paid', date: '3 days ago', icon: 'dollar' },
      { id: 4, type: 'document', action: 'Document uploaded', date: '1 week ago', icon: 'upload' },
      {
        id: 5,
        type: 'meeting',
        action: 'Client meeting scheduled',
        date: '2 weeks ago',
        icon: 'calendar',
      },
    ],
  },
  {
    profile: {
      id: 6,
      name: 'Lisa Wang',
      email: 'lwang@enterprise.com',
      phone: '+1 (555) 678-9012',
      company: 'Enterprise Solutions',
      address: '',
      dateOfBirth: '1996-05-27',
      joinDate: '2023-06-18',
      status: 'active',
      type: 'business',
      avatar: 'LW',
      tags: ['Standard'],
      notes: '',
    },
    policies: [
      {
        id: 1,
        type: 'Life Insurance',
        policyNumber: 'POL-2023-001',
        coverage: 150000,
        premium: 125,
        status: 'active',
        startDate: '2023-01-20',
        endDate: '2024-01-20',
        color: 'blue',
      },
      {
        id: 2,
        type: 'Health Insurance',
        policyNumber: 'POL-2023-045',
        coverage: 75000,
        premium: 200,
        status: 'active',
        startDate: '2023-02-15',
        endDate: '2024-02-15',
        color: 'green',
      },
      {
        id: 3,
        type: 'Auto Insurance',
        policyNumber: 'POL-2023-089',
        coverage: 25000,
        premium: 150,
        status: 'expiring',
        startDate: '2023-03-10',
        endDate: '2024-03-10',
        color: 'orange',
      },
    ],
    claims: [
      {
        id: 1,
        claimNumber: 'CLM-2024-123',
        type: 'Health Insurance',
        amount: 2500,
        status: 'approved',
        date: '2024-01-15',
        description: 'Medical procedure claim',
      },
      {
        id: 2,
        claimNumber: 'CLM-2024-089',
        type: 'Auto Insurance',
        amount: 1200,
        status: 'processing',
        date: '2024-02-20',
        description: 'Vehicle repair claim',
      },
      {
        id: 3,
        claimNumber: 'CLM-2023-456',
        type: 'Health Insurance',
        amount: 850,
        status: 'approved',
        date: '2023-11-10',
        description: 'Prescription medication',
      },
    ],
    documents: [
      {
        id: 1,
        name: 'Policy Agreement - Life Insurance.pdf',
        size: '2.4 MB',
        date: '2023-01-20',
        type: 'pdf',
      },
      { id: 2, name: 'Health Insurance Card.pdf', size: '156 KB', date: '2023-02-15', type: 'pdf' },
      { id: 3, name: 'Auto Policy Documents.pdf', size: '1.8 MB', date: '2023-03-10', type: 'pdf' },
      { id: 4, name: 'ID Verification.jpg', size: '890 KB', date: '2023-01-15', type: 'image' },
    ],
    activities: [
      { id: 1, type: 'policy', action: 'Policy renewed', date: '2 hours ago', icon: 'file' },
      { id: 2, type: 'claim', action: 'Claim approved', date: '1 day ago', icon: 'check' },
      { id: 3, type: 'payment', action: 'Premium paid', date: '3 days ago', icon: 'dollar' },
      { id: 4, type: 'document', action: 'Document uploaded', date: '1 week ago', icon: 'upload' },
      {
        id: 5,
        type: 'meeting',
        action: 'Client meeting scheduled',
        date: '2 weeks ago',
        icon: 'calendar',
      },
    ],
  },
];
